import { Component, ContentChildren, QueryList, effect, inject, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';

import { MenuItemComponent } from './menu-item/menu-item.component';
import { RootMenuService } from '../../root/root-menu/root-menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [MenuModule],
})
export class MenuComponent {
  private readonly rootMenuService = inject(RootMenuService);
  @ContentChildren(MenuItemComponent) private set menuItemsElements(value: QueryList<MenuItemComponent>) {
    this._menuItemsElements.set(value);
  }
  private readonly _menuItemsElements = signal<QueryList<MenuItemComponent> | undefined>(undefined);

  private menuItems: MenuItem[] = [];

  constructor() {
    effect(
      () => {
        this.menuItems = (this._menuItemsElements() ?? []).map(
          (item) =>
            ({
              label: item.label(),
              icon: item.icon(),
              disabled: item.disabled(),
              showDivider: item.showDivider(),
              state: {
                active: item.active(),
              },
              url: item.url(),
              command: () => item.action.emit('click'),
            }) as MenuItem,
        );

        this.rootMenuService.setMenuItems(this.menuItems);
      },
      { allowSignalWrites: true },
    );
  }

  toggle(event: Event) {
    this.rootMenuService.toggleMenu(this.menuItems, event);
  }
}
